export function customtargetEltUsedByCustomPulldownOnlyResetWidth(customtargetEltUsedByCustomPulldownOnly,
  customtargetEltUsedByCustomPulldownOnlyLocationClass, tooltipZIndex, targetEltWidth) {
  // Reset the width in case the target element has changed width
  // as in the case with responsive pages
  customtargetEltUsedByCustomPulldownOnly
    .addClass(`targetCopy ${customtargetEltUsedByCustomPulldownOnlyLocationClass}`)
    .removeClass('focus')
    .css({
      'z-index': tooltipZIndex + 1,
      width: targetEltWidth,
    });
}

export default {
  customtargetEltUsedByCustomPulldownOnlyResetWidth,
};
